import React from 'react';
import I18nProvider from '@exc-ui/exc-sdk/dist/production/localization/i18n';
import SolutionsDropdown from './SolutionsDropdown';
import * as localizationStrings from './__localization__/SolutionsDropdown';

function SolutionsDropdownWrapper({ ...props }) {
  const localeData = {};
   Object.keys(localizationStrings).map(local => {
     const localeKey = local.replace(/_/g, '-');

     localeData[localeKey] = localizationStrings[local];
  });
  return (
    <I18nProvider autoLocale={true} localeData={localeData}>
      {<SolutionsDropdown/>}
    </I18nProvider>
  );
}

SolutionsDropdownWrapper.displayName = 'SolutionsDropdownWrapper';

export default SolutionsDropdownWrapper;



// WEBPACK FOOTER //
// ./src/components/SolutionsDropdown/SolutionsDropdownWrapper.js